/**
 * Sakin giris hesabini yoneten servis.
 * Admin panelinden parola belirleme/sifirlama akisini callable function ile calistirir.
 */

import { functions, httpsCallable } from '../../firebase-config.js';

interface ManageResidentAccessInput {
    apartmentNumber: number;
    password?: string;
    disable?: boolean;
}

interface ManageResidentAccessResult {
    success: boolean;
    apartmentNumber: number;
    email: string;
    disabled: boolean;
    existed: boolean;
    uid?: string;
}

export async function manageResidentAccess(input: ManageResidentAccessInput): Promise<ManageResidentAccessResult> {
    const callable = httpsCallable(functions, 'manageResidentPassword');
    const result = await callable({
        apartmentNumber: input.apartmentNumber,
        password: input.password,
        disable: Boolean(input.disable)
    });

    return result.data as ManageResidentAccessResult;
}
